module.exports = __webpack_public_path__ + "media/flags/015-china-5a5fc27c.svg";